import r from "./_mapCacheClear.js";
import m from "./_mapCacheDelete.js";
import h from "./_mapCacheGet.js";
import l from "./_mapCacheHas.js";
import c from "./_mapCacheSet.js";
function e(t) {
  var o = -1, a = t == null ? 0 : t.length;
  for (this.clear(); ++o < a; ) {
    var p = t[o];
    this.set(p[0], p[1]);
  }
}
e.prototype.clear = r;
e.prototype.delete = m;
e.prototype.get = h;
e.prototype.has = l;
e.prototype.set = c;
export {
  e as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/_MapCache.js
// module id = 458
// module chunks = 67